<template>
    <el-card class="card">
        <template v-slot:header>
            <div class="clearfix">
                <span style="font-weight: bold;"><i class="el-icon-s-data" style="font-weight: bold;font-size: larger;margin-right: 5px;"></i>Gene Expression</span>
            </div>
        </template>
        <div>
            <div ref="chart" style="width: 100%; height: 400px;"></div>
        </div>
    </el-card>
</template>

<script>
export default {
    props: {
        species: {
            type: String,
            required: true,
        },
        tissue: {
            type: [String, Array],
            required: true,
        },
        gene: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            chart: null,
            url: "http://183.175.59.4/devenhancer/",
        };
    },
    watch: {
        species: 'fetchData',
        tissue: 'fetchData',
        gene: 'fetchData',
    },
    mounted() {
        // 初始化图表
        this.chart = this.$echarts.init(this.$refs.chart);
        // 获取并更新图表数据
        this.fetchData();
    },
    methods: {
        fetchData() {
            // 构造请求的 URL
            const params = {
                Species: this.species,
                Tissue: Array.isArray(this.tissue) ? this.tissue : [this.tissue],
                Gene: this.gene,
            };
            // 发送 HTTP 请求获取数据
            this.$axios
                .get(this.url + "Geneen" + "/", { params })
                .then((response) => {
                    // 处理数据格式
                    const data = response.data;
                    // 初始化一个包含所有组织的数组，初始值为0
                    const defaultTpmValues = (Array.isArray(this.tissue) ? this.tissue : [this.tissue]).reduce((acc, current) => {
                        acc[current] = 0;
                        return acc;
                    }, {});
                    // 将真实的 TPM 值填充到对应的位置
                    const tissueMap = data.reduce((acc, entry) => {
                        acc[entry.Tissue] = parseFloat(entry.TPM);
                        return acc;
                    }, defaultTpmValues);
                    // 更新图表配置
                    this.updateChart({
                        xAxisData: Array.isArray(this.tissue) ? this.tissue : [this.tissue], // 使用组织选项中的值顺序
                        seriesData: (Array.isArray(this.tissue) ? this.tissue : [this.tissue]).map(tissue => tissueMap[tissue]),
                    });
                })
                .catch((error) => {
                    console.error('Error fetching data:', error);
                });
        },
        updateChart(data) {
            this.chart.setOption({
                title: {
                    text: `${this.gene} Expression`, // 使用 gene 属性
                    left: 'center', // 居中
                    top: 'top', // 顶部对齐
                },
                xAxis: {
                    type: 'category',
                    data: data.xAxisData, // 使用传递的 tissue 参数
                    name: 'tissue',
                },
                yAxis: {
                    type: 'value',
                    name: 'TPM', // 设置 y 轴标题为 'TPM'
                },
                tooltip: {
                    trigger: 'axis',
                    formatter: function (params) {
                        const dataIndex = params[0].dataIndex;
                        const tissue = data.xAxisData[dataIndex];
                        const tpm = data.seriesData[dataIndex];
                        return `Tissue: ${tissue}<br>TPM: ${tpm}`;
                    },
                },
                series: [
                    {
                        name: 'GeneExpression',
                        type: 'line',
                        smooth: true, // 平滑曲线
                        symbolSize: 20, // 设置点的大小
                        areaStyle: {
                            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                { offset: 0, color: 'rgba(255, 158, 68, 0.8)' }, // 渐变的起始颜色
                                { offset: 1, color: 'rgba(255, 70, 131, 0.3)' }, // 渐变的结束颜色
                            ]),
                        },
                        data: data.seriesData,
                    },
                ],
            });
        },
    },
    beforeDestroy() {
        // 销毁图表
        if (this.chart) {
            this.chart.dispose();
        }
    },
};
</script>

<style scoped>
.card{
    margin-top: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/home/Genefig.vue